/** React libraries */
import React, { JSX, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { logout } from './../services/authService';

/** Custom components */
import Sidebar from "../components/Sidenav/sidenav.components";
import Login from "../pages/Login/Login";
import Logout from "../hooks/logout";
import Callback from "../hooks/callback";
import Dashboard from "../pages/Dashboard/Dashboard";
import FAQ from "../pages/FAQ/FAQ";
import ManageBanners from "../pages/Banner Management/BannerManagement";
import useAuth from "../context/AuthContext";
import { AUTH_STATUS } from "../utils/authUtils";


const ProtectedRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("access_token");
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      logout();
    }
  }, [isAuthenticated, navigate]);

  if (isAuthenticated) {
    return children;
  }
  return null;
};

export const AppRouter: React.FC = () => {
  const { AUTHENTICATED } = AUTH_STATUS;
  const { status } = useAuth();
  return (
    <div className="app-container">
      {status === AUTHENTICATED &&
        <Sidebar />
      }
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/callback" element={<Callback />} />
          <Route path="/manageBanners" element={
            <ProtectedRoute>
              <ManageBanners />
            </ProtectedRoute>
          } />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>}
          />
          <Route path="/faqs" element={<FAQ />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="*" element={<Login />} />
        </Routes>
      </div>
    </div>
  );
};
